export default "__VITE_ASSET__Cq_BPYjl__"